import React from 'react';
import { Route, IndexRedirect, Redirect } from 'react-router';

// redux-auth-wrapper
import {
  internalUserIsAuthenticated,
  externalUserIsAuthenticated,
  internalOrPartnerUserIsAuthenticated
} from './authWrappers';

import AppLayout from '../containers/AppLayout';
import RouteUser from '../components/RouteUser';

// Protected Assessment Pages
import TemplateDownloaderPage from '../containers/TemplateDownloaderPage';
import KeyGoals from '../containers/KeyGoals';
import Usage from '../containers/Usage';
import Sources from '../containers/Sources';
import Correlations from '../containers/Correlations';
import { LoadingScreen } from '@its-svp/svp-common-ui';

// Protect CoE Pages
import CoEContainer from '../CoE/CoEContainer';

import renderAnalyticsRoutes from './renderAnalyticsRoutes';
import renderAnalyticsPPTXPreviewRoutes from './renderAnalyticsPPTXPreviewRoutes';

const InternalUserIsAuthenticated = internalUserIsAuthenticated(props => React.cloneElement(props.children, props));
const ExternalUserIsAuthenticated = externalUserIsAuthenticated(props => React.cloneElement(props.children, props));
const InternalOrPartnerUserIsAuthenticated = internalOrPartnerUserIsAuthenticated(props => React.cloneElement(props.children, props));

const createRoutes = () => (
  <Route path='/' component={AppLayout}>
    {/* Public Routes - No login required */}
    {/* TODO login should be removed after the first phase of the home service handling sessions */}
    <Route path='login' component={() => { window.location.replace('/svp/login'); return null; }} />
    <Route path='loading' component={LoadingScreen} />

    {/* Pages that require an authenticated user */}
    <Route component={InternalUserIsAuthenticated}>
      <Route path='/templates/dsa' component={() => <TemplateDownloaderPage dsaType='full' />} />
      <Route path='/templates/new-customer' component={() => <TemplateDownloaderPage dsaType='new-customer' />} />
      <Redirect from='account/:accountId/dsa/:slug/goals' to='account/:accountId/dsa/:slug/sources' />
      <Route path='account/:accountId/dsa/:slug/goals(/:area)' component={KeyGoals} />
      <Route path='account/:accountId/dsa/:slug/usage(/:area)' component={Usage} />
      <Route path='account/:accountId/dsa/:slug/sources(/:area)' component={Sources} />
      <Route path='account/:accountId/dsa/:slug/correlations/:id' component={Correlations} />

      {renderAnalyticsRoutes('account/:accountId/dsa/:slug/analytics')}
      {renderAnalyticsPPTXPreviewRoutes('account/:accountId/dsa/:slug/pptx/preview')}

    </Route>

    <Route component={InternalOrPartnerUserIsAuthenticated}>
      <Route path='dsa/account/:accountId/assessment/:slug' >
        <IndexRedirect to='sources' />
        <Redirect from='goals' to='sources' />
        <Route path='goals/:area' component={KeyGoals} />
        <Route path='usage(/:area)' component={Usage} />
        <Route path='sources(/:area)' component={Sources} />
        <Route path='correlations/:id' component={Correlations} />
      </Route>
      {renderAnalyticsRoutes('dsa/account/:accountId/assessment/:slug/analytics')}
      {renderAnalyticsPPTXPreviewRoutes('dsa/account/:accountId/assessment/:slug/pptx/preview')}
    </Route>

    <Route component={ExternalUserIsAuthenticated}>
      <Route path='/coe' component={CoEContainer} />
    </Route>

    <Route path='*' component={RouteUser} />

  </Route>
);

export default createRoutes;



// WEBPACK FOOTER //
// ./src/routing/index.js